import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X, Download, Briefcase } from 'lucide-react';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const navItems = [
    { id: 'home', label: 'Home' },
    { id: 'about', label: 'About' },
    { id: 'skills', label: 'Expertise' },
    { id: 'impact', label: 'Impact' },
    { id: 'experience', label: 'Experience' },
    { id: 'projects', label: 'Platforms' },
    { id: 'contact', label: 'Contact' }
  ];

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMenuOpen(false);
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-page border-b border-border-medium">
      <div className="container mx-auto px-8 py-4">
        <nav className="flex items-center justify-between">
          <div className="text-brand-primary font-bold text-xl" data-testid="header-logo">
            Anna Krat
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-7">
            {navItems.map((item) => (
              <button
                key={item.id}
                onClick={() => scrollToSection(item.id)}
                className="nav-link"
                data-testid={`nav-${item.id}`}
              >
                {item.label}
              </button>
            ))}
            <Link to="/consulting" className="nav-link inline-flex items-center gap-1.5" data-testid="nav-consulting">
              <Briefcase size={15} />
              Consulting
            </Link>
            <a
              href="/Anna-Krat-CV.pdf"
              download="Anna-Krat-CV.pdf"
              className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-brand-primary text-white text-sm font-medium hover:bg-brand-hover transition-colors"
              data-testid="header-download-cv-btn"
            >
              <Download size={16} />
              CV
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-brand-primary"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            data-testid="mobile-menu-toggle"
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </nav>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden mt-4 py-4 border-t border-border-medium">
            <div className="flex flex-col space-y-4">
              {navItems.map((item) => (
                <button
                  key={item.id}
                  onClick={() => scrollToSection(item.id)}
                  className="nav-link text-left"
                  data-testid={`mobile-nav-${item.id}`}
                >
                  {item.label}
                </button>
              ))}
              <Link to="/consulting" className="nav-link text-left inline-flex items-center gap-1.5" data-testid="mobile-nav-consulting">
                <Briefcase size={15} />
                Consulting
              </Link>
              <a
                href="/Anna-Krat-CV.pdf"
                download="Anna-Krat-CV.pdf"
                className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-brand-primary text-white text-sm font-medium hover:bg-brand-hover transition-colors w-fit"
                data-testid="mobile-download-cv-btn"
              >
                <Download size={16} />
                Download CV (PDF)
              </a>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
